import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { visuallyHidden } from '@mui/utils';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { Collapse, Container, Menu, MenuItem, Stack, TextField } from '@mui/material';
import moment from 'moment';
import { useTheme } from '@emotion/react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { DateRange } from 'react-date-range';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import Empty from '../components/Empty';
import useAxiosPrivate from '../hooks/use-axios-private';
import { BASE_URL } from '../utils/apiUtils';
import useAuth from '../hooks/use-auth';
import { ROLE, APP_CURRENCY, APP_DATE_FORMAT } from '../constants';

const Row = ({ row }) => {
    // const { row } = props;
    const [open, setOpen] = React.useState(false);
    const theme = useTheme()
    const { protector } = useAuth()
    return (

        <React.Fragment>
            <TableRow sx={{ height: { xs: 60, xl: 70 } }}>
                <TableCell sx={{ borderBottom: "0px" }}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {<KeyboardArrowDownIcon sx={{ rotate: !open ? "0deg" : "-180deg", transition: ".3s all ease" }} />}
                    </IconButton>
                </TableCell>
                {protector([ROLE.admin]) &&
                    <TableCell sx={{ borderBottom: "0px", whiteSpace: "pre-wrap" }} align="center">
                        {row.full_name}
                    </TableCell>
                }
                <TableCell sx={{ borderBottom: "0px", whiteSpace: "pre-wrap" }} align="center">#INV{row.id}</TableCell>
                <TableCell sx={{ borderBottom: "0px", whiteSpace: "pre-wrap", minWidth: "250px", maxWidth: "250px", textTransform: "capitalize" }} align="center">{row.job_title}</TableCell>
                <TableCell sx={{ borderBottom: "0px", whiteSpace: "nowrap" }} align="center">{row.job_id}</TableCell>
                <TableCell sx={{ borderBottom: "0px", whiteSpace: "nowrap" }} align="center">{row.file_count}</TableCell>
                <TableCell sx={{ borderBottom: "0px", whiteSpace: "nowrap" }} align="center">{moment(row.created_on).format(APP_DATE_FORMAT)}</TableCell>
                <TableCell sx={{ borderBottom: "0px", whiteSpace: "nowrap" }} align="center">{APP_CURRENCY.currency_symbol} {row.net_price}</TableCell>
                <TableCell sx={{ borderBottom: "0px", whiteSpace: "nowrap" }} align="center">
                    <a href={`${BASE_URL}/jobs/generate_invoice_pdf/${row.id}`}>
                        <IconButton>
                            <CloudDownloadOutlinedIcon color='primary' />
                        </IconButton>
                    </a>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ padding: 0, }} colSpan={9}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ my: 2 }}>
                            <Table size="medium" aria-label="purchases">
                                <TableHead>
                                    <TableRow sx={{ fontWeight: "500", backgroundColor: theme.palette.mode === "dark" ? 'background.stripped' : 'background.stripped' }}>
                                        <TableCell align='center' sx={{ whiteSpace: "nowrap" }}></TableCell>
                                        <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>Service</TableCell>
                                        <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>Unit Price ({APP_CURRENCY.currency_symbol})</TableCell>
                                        <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>Image Count</TableCell>
                                        <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>Total ({APP_CURRENCY.currency_symbol})</TableCell>
                                        <TableCell align='center' sx={{ whiteSpace: "nowrap" }}></TableCell>
                                        <TableCell align='center' sx={{ whiteSpace: "nowrap" }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.item_lst.map((item, index) => (
                                        <TableRow key={index} sx={{ backgroundColor: theme.palette.mode === "dark" ? 'background.stripped' : 'background.stripped' }}>
                                            <TableCell align='center' sx={{ whiteSpace: "nowrap" }}></TableCell>
                                            <TableCell align='center' sx={{ whiteSpace: "nowrap", textTransform: "capitalize" }}>{item.title}</TableCell>
                                            <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{APP_CURRENCY.currency_symbol} {item.item_price}</TableCell>
                                            {item.file_count
                                                ?
                                                <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{item.file_count}</TableCell>
                                                :
                                                <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>--</TableCell>
                                            }
                                            <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{APP_CURRENCY.currency_symbol} {item.item_total}</TableCell>
                                            <TableCell align='center' sx={{ whiteSpace: "nowrap" }}></TableCell>
                                            <TableCell align='center' sx={{ whiteSpace: "nowrap" }}></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

Row.propTypes = {
    row: PropTypes.shape({
        job_title: PropTypes.string.isRequired,
        job_id: PropTypes.number.isRequired,
        file_count: PropTypes.number.isRequired,
    }).isRequired,
};

const headCells = [
    {
        id: 'id',
        numeric: true,
        disablePadding: false,
        label: 'Invoice Number',
    },
    {
        id: 'job_title',
        numeric: true,
        disablePadding: false,
        label: 'Job Title',
    },
    {
        id: 'id',
        numeric: false,
        disablePadding: true,
        label: 'Order ID',
    },
    {
        id: 'file_count',
        numeric: true,
        disablePadding: false,
        label: 'Total Files',
    },
    {
        id: 'created_on',
        numeric: true,
        disablePadding: false,
        label: 'Created On',
    },
    {
        id: 'net_price',
        numeric: true,
        disablePadding: false,
        label: `Price (${APP_CURRENCY.currency_symbol})`,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Download',
    },

];

const DEFAULT_ROWS_PER_PAGE = 5;

const EnhancedTableHead = (props) => {
    const { protector } = useAuth()
    const { order, orderBy, onRequestSort } =
        props;

    const createSortHandler = (newOrderBy) => {
        onRequestSort(newOrderBy);
    };
    return (
        <TableHead>
            <TableRow sx={{ height: { xs: 65, xl: 70 } }}>
                <TableCell padding="checkbox">
                </TableCell>
                {protector([ROLE.admin]) &&
                    <TableCell>
                        Client Names
                    </TableCell>
                }
                {headCells.map((headCell, index) => (
                    <TableCell
                        key={index}
                        align={'center'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ whiteSpace: "nowrap" }}
                    >
                        {
                            headCell.id !== 'action'
                                ?
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy}
                                    onClick={() => createSortHandler(headCell.id)}
                                >
                                    {headCell.label}
                                    {orderBy === headCell.id && (
                                        <Box component="span" sx={visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </Box>
                                    )
                                    }
                                </TableSortLabel>
                                :
                                headCell.label
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const [showFilter, setShowFilter] = useState(false)
    const [toggleDatePicker, setToggleDatePicker] = useState(false)
    const { numSelected, onSearchChange, filter, filterChange } = props
    const { user } = useAuth()
    const theme = useTheme()
    const [appliedFilter, setAppliedFilter] = useState("ALL")
    const [filterCondition, setFilterCondition] = useState(
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    )

    const onFilterChange = (e) => {
        if (e !== "CUSTOM") {
            setAppliedFilter(e)
        }
        if (e === "CUSTOM") {
            setToggleDatePicker(true)
            return
        }
        else if (e === "7DAYS") {
            const date = new Date()
            const currentDate = moment()
            const sevenDays = date.setDate(date.getDate() - 6)
            const last7Days = moment(sevenDays)
            const filterCondition = {
                startDate: moment.utc(last7Days).format(),
                endDate: moment.utc(currentDate).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_30_DAYS") {
            const date = new Date()
            const currentDate = moment()
            const thirtyDays = date.setDate(date.getDate() - 30)
            const last30Days = moment(thirtyDays)
            const filterCondition = {
                startDate: moment.utc(last30Days).format(),
                endDate: moment.utc(currentDate).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_MONTH") {
            const date = new Date()
            const currentYear = date.getFullYear()
            const month = date.setMonth(date.getMonth() - 1)
            const NumberOfDaysInMonth = new Date(month);
            const firstDay = new Date(currentYear, NumberOfDaysInMonth.getMonth(), 1);
            let lastDay = new Date(currentYear, NumberOfDaysInMonth.getMonth() + 1, 0);
            const filterCondition = {
                startDate: moment.utc(firstDay).format(),
                endDate: moment.utc(lastDay).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_3_MONTH") {
            const date = new Date()
            const currentYear = date.getFullYear()
            const setLast3Month = date.setMonth(date.getMonth() - 3)
            const setLastmonth = date.setMonth(date.getMonth() + 2)
            const lastMonth = new Date(setLastmonth);
            const last3Month = new Date(setLast3Month);
            const firstDay = new Date(currentYear, last3Month.getMonth(), 1);
            const lastDay = new Date(currentYear, lastMonth.getMonth() + 1, 0);
            const filterCondition = {
                startDate: moment.utc(firstDay).format(),
                endDate: moment.utc(lastDay).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "ALL") {
            const filterCondition = {
                startDate: '',
                endDate: '',
            }
            filterChange(filterCondition)
        }
        setShowFilter(false)
    }
    return (
        <>
            <Box sx={{ mt: 3 }}>
                <Toolbar
                    sx={{

                        px: 2,
                        ...(numSelected > 0 && {
                            bgcolor: (theme) =>
                                alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                        }),
                        alignItems: { xs: 'end' }
                    }}
                >
                    {numSelected > 0 ? (
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            color="inherit"
                            variant="subtitle1"
                            component="div"
                        >
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'start', md: 'end' }} justifyContent='space-between' sx={{ width: '100%', mt: { xs: 2, md: 0 } }}>
                            <Typography
                                sx={{ flex: '1 1 100%', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}
                                id="tableTitle"
                                component="div"
                            >
                                Credits/Balance
                            </Typography>

                            <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} alignItems="end" justifyContent="end" sx={{ width: '100%' }}>
                                <Stack direction='row' spacing={2} sx={{ mt: { xs: 2, md: 0 } }}>
                                    <a href={`${BASE_URL}/jobs/generate_invoice_csv/?start_date=${filter.startDate}&end_date=${filter.endDate}&user_id=${user.id}`}>
                                        <Button variant="outlined" >CSV</Button>
                                    </a>

                                    <a href={`${BASE_URL}/jobs/generate_invoice_report/?start_date=${filter.startDate}&end_date=${filter.endDate}&user_id=${user.id}`}>
                                        <Button variant="outlined">Excel</Button>
                                    </a>
                                </Stack>

                                <Box sx={{ mr: 3, width: { xs: '100%', md: 300 }, maxWidth: '100%', pr: { xs: 0, sm: 2 } }}>
                                    <TextField fullWidth label="Search" variant="standard" size="small" type='search' onChange={onSearchChange} autoComplete='off' />
                                </Box>
                            </Stack>
                        </Stack>
                    )}

                    {numSelected > 0 ? (
                        <>
                            <Tooltip title="Delete">
                                <IconButton color='error'>
                                    <DeleteOutlineOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Duplicate">
                                <IconButton>
                                    <ContentCopyOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit">
                                <IconButton>
                                    <EditOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ) : (
                        <>
                            <Tooltip title="Filter">
                                <Badge overlap="circular" badgeContent=" " color="secondary" invisible={appliedFilter === 'ALL'} variant="dot">
                                    <IconButton sx={{ backgroundColor: '#f3f3f3' }} onClick={(e) => {
                                        setShowFilter(prev => {
                                            return prev ? false : e.target
                                        })
                                    }}>
                                        <FilterAltOutlinedIcon />
                                    </IconButton>
                                </Badge>
                            </Tooltip>

                            <Menu
                                open={showFilter}
                                anchorEl={showFilter}
                                onClose={() => { setShowFilter(false); setToggleDatePicker(false) }}
                            >
                                {toggleDatePicker ?
                                    <DateRange
                                        maxDate={new Date()}
                                        editableDateInputs={true}
                                        onChange={(item) => {
                                            setFilterCondition(item.selection)
                                            let nextDay = new Date(item.selection.endDate.getTime())
                                            nextDay.setHours(item.selection.endDate.getHours() + 24)
                                            let lastDate = moment.utc(item.selection.endDate).format()
                                            lastDate = moment(lastDate).set({ 'hour': 23, 'minute': 59, 'second': 59 })
                                            filterChange(
                                                {
                                                    startDate: moment.utc(item.selection.startDate).format(),
                                                    endDate: item.selection.startDate.getTime() === item.selection.endDate.getTime()
                                                        ?
                                                        moment.utc(nextDay).format()
                                                        :
                                                        moment.utc(lastDate).format()
                                                }
                                            )
                                            setAppliedFilter("CUSTOM")
                                        }}
                                        moveRangeOnFirstSelection={false}
                                        ranges={[filterCondition]}
                                    />
                                    :
                                    <Box>
                                        <MenuItem onClick={() => onFilterChange('ALL')} sx={appliedFilter === "ALL" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }} >All</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('7DAYS')} sx={appliedFilter === "7DAYS" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Last 7 days</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('LST_30_DAYS')} sx={appliedFilter === "LST_30_DAYS" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Last 30 days</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('LST_MONTH')} sx={appliedFilter === "LST_MONTH" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Last month</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('LST_3_MONTH')} sx={appliedFilter === "LST_3_MONTH" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Last 3 months</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('CUSTOM')} sx={appliedFilter === "CUSTOM" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Custom range</MenuItem>
                                    </Box>
                                }
                            </Menu>
                        </>
                    )}
                </Toolbar>
            </Box>
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const Invoicepage = ({ jobstatus }) => {
    const theme = useTheme()
    const [ascorder, setAscorder] = useState("desc")
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
    const [paddingHeight, setPaddingHeight] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [count, setCount] = useState(0);
    const axios = useAxiosPrivate()

    const [orderByJobs, setOrderByJobs] = useState([])
    const [bill, setBill] = useState([])
    const [filter, setFilter] = useState(
        {
            startDate: '',
            endDate: '',
            key: 'selection'
        }
    );

    const invoices = async () => {
        try {
            const resp = await axios.get('jobs/invoices/', {
                params: {
                    limit: rowsPerPage, search: searchText, page: page + 1, status: jobstatus
                    , order_by: orderByJobs, order_by_type: ascorder,
                    start_date: filter.startDate,
                    end_date: filter.endDate
                }
            })
            setBill(resp.data.data.job_payments)
            setCount(resp.data.data.page_info.count)

        } catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        invoices()
    }, [rowsPerPage, searchText, page, ascorder, orderByJobs, filter]);


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            return;
        }
        setSelected([]);
    };
    const orderChange = (newOrderBy) => {
        if (newOrderBy === 'action') {
            return false
        }

        if (ascorder === "desc") {
            setAscorder("asc")
            setOrderByJobs(newOrderBy)
        }
        else {
            setAscorder("desc")
            setOrderByJobs(newOrderBy)
        }
    }


    const handleChangePage = useCallback(
        (event, newPage) => {
            setPage(newPage)
        },
        []
    );

    const handleChangeRowsPerPage = useCallback(
        (event) => {
            const updatedRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(updatedRowsPerPage);
            setPage(0);
            // There is no layout jump to handle on the first page.
            setPaddingHeight(0);
        }, []
    );
    return (
        <Container maxWidth="xl">
            <Stack>
                <Box sx={{ mt: 3 }}>
                    <Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Credits/Balance</Typography>
                </Box>
            </Stack>
            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', mb: 2, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                    <Box>
                        <EnhancedTableToolbar
                            numSelected={selected.length}
                            onSearchChange={
                                (e) => {
                                    setSearchText(e.target.value)
                                }
                            }
                            filterChange={
                                (e) => {
                                    setFilter(e)
                                }
                            }
                            filter={filter}
                        />
                        {bill.length > 0
                            ?
                            <>
                                <TableContainer>
                                    <Table
                                        sx={{ minWidth: 750, mt: 3 }}
                                        aria-labelledby="tableTitle"
                                        size={"small"}
                                    >
                                        <EnhancedTableHead
                                            numSelected={selected.length}
                                            //   order={order}
                                            //  orderBy={orderBy}
                                            onSelectAllClick={handleSelectAllClick}

                                            //  onRequestSort={orderChange}
                                            onRequestSort={(newOrderBy) => { orderChange(newOrderBy) }}
                                            rowCount={bill.length}
                                            orderBy={ascorder}
                                        />
                                        <TableBody>
                                            {bill
                                                && bill.map((row, index) => <Row key={row.id} row={row} />)
                                            }
                                            {paddingHeight > 0 && (
                                                <TableRow
                                                    style={{
                                                        height: paddingHeight,
                                                    }}
                                                >
                                                    <TableCell colSpan={8} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={count}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </>
                            :
                            <Empty sx={{ border: "none", }} icon={<DescriptionOutlinedIcon sx={{ fontSize: 40, color: "grey" }} />} text="No invoices available" />
                        }
                    </Box>
                </Paper>
            </Box>
        </Container>

    );
}

export default Invoicepage